import { render, staticRenderFns } from "./MMP_ANSI_FeatureTable.vue?vue&type=template&id=5989cf27&"
import script from "./MMP_ANSI_FeatureTable.vue?vue&type=script&lang=js&"
export * from "./MMP_ANSI_FeatureTable.vue?vue&type=script&lang=js&"
import style0 from "./MMP_ANSI_FeatureTable.vue?vue&type=style&index=0&id=5989cf27&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports